<template>
  <div>
    <div class="container">
      <h3 class="title" @click="showHidden">店铺信息</h3>

      <el-form style="margin-left: 15px;" :model="form" :rules="rules" label-width="120px" label-position="left" ref="form" size="small">
        <!-- 名称 -->
        <el-form-item label="商城名" prop="name">
          <el-col span="5">
            <el-input v-model="form.name"></el-input>
          </el-col>
        </el-form-item>
        <!-- 添加商家LOGO -->
        <el-form-item label="商城LOGO" prop="logo">
          <upload-file :limit="1" accept="image/*" v-model="form.logo"></upload-file>
          <div class="tips">建议尺寸：1:1，最多上传1张</div>
        </el-form-item>
        <!-- 简介 -->
        <el-form-item label="商城简介" prop="longarticle">
          <el-col span="16">
            <el-input v-model="form.longarticle" type="textarea"></el-input>
          </el-col>
        </el-form-item>
        <!-- 添加商品图 -->
        <el-form-item label="商城照片" prop="photolistList">
          <upload-file :limit="10" accept="image/*" v-model="form.photolistList"></upload-file>
          <div class="tips">建议尺寸：3:2，最多上传10张</div>
        </el-form-item>
        <!-- 联系电话 -->
        <el-form-item label="客服电话" prop="consumerhotline">
          <el-col span="5">
            <el-input v-model="form.consumerhotline"></el-input>
          </el-col>
        </el-form-item>
        <!-- 营业时间 -->
        <el-form-item label="营业时间">
          <el-row class="hours-list" :key="index" v-for="(item, index) in form.businesshoursList">
            <el-col span="5">
              <el-time-select
                style="width: 100%;"
                placeholder="起始时间"
                v-model="item.begin"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '24:00'
                }"
              >
              </el-time-select>
            </el-col>
            <el-col style="margin-left: 10px;" span="5">
              <el-time-select
                style="width: 100%;"
                placeholder="结束时间"
                v-model="item.end"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '24:00'
                }"
              >
              </el-time-select>
            </el-col>
            <el-col span="2" style="margin-left: 10px;">
              <i @click="onClickSwitchOut(index)" :style="item.isout ? 'color: #ff4f4f' : 'color: #999;'" class="el-icon-success"></i>
              <span @click="onClickSwitchOut(index)" style="color: #999; margin-left: 5px; cursor: pointer; user-select: none;">营业至次日</span>
            </el-col>
            <el-col v-if="index < 4 && index === form.businesshoursList.length - 1" span="1" style="margin-left: 10px;">
              <i @click="onClickAddHoursButton" style="font-size: 20px; color: #ff4f4f; margin-top: 6px;" class="el-icon-circle-plus-outline"></i>
            </el-col>
            <el-col v-else span="1" style="margin-left: 10px;">
              <i @click="onClickRemoveHoursButton(index)" style="font-size: 20px; color: #ff4f4f; margin-top: 6px;" class="el-icon-remove-outline"></i>
            </el-col>
          </el-row>
        </el-form-item>
        <!-- 店铺地址 -->
        <el-form-item label="店铺地址">
          <el-row>
            <el-col span="14">
              <div style="width:100%;float:left;box-sizing:border-box;display:block;line-height:32px;font-size:14px;">
                <div style="font-size:13px;position:relative;display:inline-block;width:100%;">
                  <input id="pickInput" v-model="form.storeaddress" style="height:32px;line-height:32px;-webkit-appearance:none;background-color:#fff;background-image:none;border-radius:4px;border: 1px solid #dcdfe6;box-sizing:border-box;color:#606266;display:inline-block;font-size:inherit;outline:none;padding:0 15px;transition:border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);width:100%" />
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <p class="tips1">
        地址填写方法: 先输入地址搜索, 从搜索列表中点击某个结果(此时地图会更新), 再在输入框后面补充几号楼几单元门牌号等信息
      </p>
      <p class="tips1">
        如果地址不准确会导致无法接单等系列问题，门店地址请填写详细地址（如：西直门外大街1号凯德嘉茂 1层1112号）
      </p>
      <div id="map-wrapper" class="map-wrapper"></div>

      <div style="height: 100px;"></div>

      <div class="buttons">
        <el-button :loading="saveLoading" @click="onSubmit" type="primary">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';
import uploadFile from '../../../components/uploadFile/index.vue';
import $ from 'jquery';
import AMapLoader from '@amap/amap-jsapi-loader';

export default {
  components: {
    'upload-file': uploadFile
  },
  data() {
    return {
      showHiddenN: 0,
      token: '',
      form: {
        storeaddress: '',
        businesshoursList: [{ begin: '', end: '', isout: false }]
      },
      addressList: [],
      saveLoading: false
    };
  },
  async mounted() {
    this.token = getToken();
    this.loading = this.$loading({ text: '请求中...', background: '#fff', target: '#sansanll-content' });
    const res = await rpc('StoreAuthService.GetStore', M('Token', { token: this.token }));
    res.businesshoursList = res.businesshoursList.map(item => {
      return {
        ...item,
        isout: item.end.startsWith(':'),
        end: item.end.startsWith(':') ? item.end.slice(1) : item.end
      };
    });
    res.businesshoursList = res.businesshoursList.length ? res.businesshoursList : [{ begin: '', end: '', isout: false }];
    res.longitude = res.longitude || '116.397474';
    res.latitude = res.latitude || '39.908696';
    this.form = res;
    this.initMap();
  },

  methods: {
    showHidden() {
      this.showHiddenN++;
      if(this.showHiddenN >= 5){
        localStorage.setItem("showHidden", "true");
        alert("OK")
      }
    },
    initMap() {
        AMapLoader.load({
            "key": localStorage.getItem('amapjskey'),              // 申请好的Web端开发者Key，首次调用 load 时必填
            "plugins": ['AMap.ToolBar'],           // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            "AMapUI": {             // 是否加载 AMapUI，缺省不加载
                "version": '1.1',   // AMapUI 版本
                "plugins":['misc/PoiPicker'],       // 需要加载的 AMapUI ui插件
            },
        }).then((AMap)=>{
          // https://lbs.amap.com/api/javascript-api/reference-amap-ui/other/poipicker
          AMapUI.setDomLibrary($);
          AMapUI.loadUI(['misc/PoiPicker'], PoiPicker => {
            const map = new AMap.Map('map-wrapper', { zoom: 18, scrollWheel: false });
            const poiPicker = new PoiPicker({
              input: 'pickInput',
            });
            const marker = new AMap.Marker();
            poiPicker.on('poiPicked', poiResult => {
              this.form.longitude = poiResult.item.location.lng.toString();
              this.form.latitude = poiResult.item.location.lat.toString();
              this.form.storeaddress = poiResult.item.address + ' ' + poiResult.item.name;
              marker.setMap(map);
              marker.setPosition(poiResult.item.location);
              map.setCenter(marker.getPosition());
            });
            map.panBy(0, 1);
            map.addControl(new AMap.ToolBar({ liteStyle: true }));
            /* poiPicker.onCityReady(() => { */
              marker.setMap(map);
              marker.setPosition(new AMap.LngLat(this.form.longitude, this.form.latitude));
              map.setCenter(marker.getPosition());
              this.loading.close();
            /* }); */
          });
        }).catch((e)=>{
            alert(`${e}`);
        });
    },

    onSubmit() {
      this.saveLoading = true;
      const params = JSON.parse(JSON.stringify(this.form));
      params.businesshoursList = params.businesshoursList.filter(item => item.begin && item.end);
      params.businesshoursList = params.businesshoursList.map(item => {
        const { begin, end, isout } = item;
        return {
          begin,
          end: isout ? `:${end}` : end
        };
      });
      rpc(
        'StoreStoreService.UpdateInfo',
        M('StoreWithTokenRequest', {
          token: M('Token', { token: this.token }),
          store: M('Store', {
            ...params,
            businesshoursList: params.businesshoursList.map(v => M('BusinessHours', v)),
            distancepricelistList: params.distancepricelistList.map(v => M('DistancePrice', v))
          })
        })
      )
        .then(res => {
          gtag('event', 'saveshopinfo', {
            value: 100
          });
          this.$message({
            message: '更新成功',
            type: 'success'
          });
          this.saveLoading = false;
          location.reload();
        })
        .catch(() => {
          this.saveLoading = false;
        });
    },

    onClickAddHoursButton() {
      if (this.form.businesshoursList.length === 5) return;
      this.form.businesshoursList.push({ begin: '', end: '', isout: false });
    },
    onClickRemoveHoursButton(i) {
      this.form.businesshoursList = this.form.businesshoursList.filter((item, index) => index !== i);
    },
    onClickSwitchOut(index) {
      this.form.businesshoursList[index].isout = !this.form.businesshoursList[index].isout;
    }
  }
};
</script>

<style scoped>
.map-wrapper {
  width: 600px;
  height: 300px;
  margin-left: 135px;
}
.container {
  background-color: #fff;
  border-radius: 4px;
  padding: 15px;
  margin-top: 15px;
}
.tips {
  margin: 0;
  padding: 0;
  line-height: 1.4;
  padding-top: 4px;
  font-size: 12px;
  color: #aaa;
}
.tips.nopt {
  padding-top: 0;
}
.tips.bold {
  color: #333;
}
.title {
  padding: 0;
  margin: 0;
  color: #333;
  padding: 15px;
  padding-bottom: 30px;
}
.button-plus {
  box-sizing: border-box;
  border: 1px solid #999;
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: #999;
  border-radius: 3px;
  font-size: 20px;
}
.hours-list {
  margin-top: 10px;
}
.hours-list:first-child {
  margin-top: 0;
}
.buttons {
  background-color: #f8f8f8;
  padding: 15px 30px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 200px;
  display: flex;
  display: flex;
  justify-content: flex-end;
  /* justify-content: flex-end; */
}
.tips1 {
  width: 64%;
  padding-left: 136px;
  margin-top: 0;
  line-height: 16px;
  color: #aaa;
}
</style>
